interface CategoryNavProps {
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
}

const categories = [
  { id: 'all', name: 'All Topics', icon: 'ri-apps-line' },
  { id: 'ai', name: 'Artificial Intelligence', icon: 'ri-robot-line' },
  { id: 'blockchain', name: 'Blockchain', icon: 'ri-links-line' },
  { id: 'quantum', name: 'Quantum Computing', icon: 'ri-cpu-line' },
  { id: 'iot', name: 'IoT', icon: 'ri-wifi-line' },
  { id: 'cybersecurity', name: 'Cybersecurity', icon: 'ri-lock-line' },
  { id: 'ar-vr', name: 'AR/VR', icon: 'ri-glasses-line' },
  { id: 'biotech', name: 'BioTech', icon: 'ri-dna-line' },
];

export default function CategoryNav({ selectedCategory, onCategoryChange }: CategoryNavProps) {
  return (
    <div id="categories" className="bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 py-6 sticky top-[81px] z-40 border-b border-cyan-500/20 shadow-lg shadow-cyan-500/10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center gap-3 overflow-x-auto pb-2 scrollbar-hide">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => onCategoryChange(category.id)}
              className={`flex items-center gap-2.5 px-6 py-3 rounded-lg whitespace-nowrap transition-all cursor-pointer font-medium text-sm ${
                selectedCategory === category.id
                  ? 'bg-gradient-to-r from-cyan-500 to-blue-600 text-white shadow-lg shadow-cyan-500/40 scale-105'
                  : 'bg-slate-800/50 text-gray-300 hover:bg-slate-700/70 border border-cyan-500/20 hover:border-cyan-500/40 hover:text-white'
              }`}
            >
              <i className={`${category.icon} text-lg`}></i>
              <span>{category.name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
